import useAuth from '@/data/hook/useAuth';
import { isTeacher } from '@/functions/auth';

export default function useScopedTeacher(teacher?: number) {
  const { user } = useAuth();

  return isTeacher(user?.userType) && user ? user.id : teacher;
}
